module.exports = __webpack_public_path__ + "app-static/img/bg-1.fd3c7676.png";